var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthArtilceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_35_10539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_35_10539",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_35_10539",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_35_10539",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA7ElEQVR4nO2UsQrCQBAFB1G0sBE/2Q+wsBfsBVvBVjtB/KJnYyGLooaEzYY3cJAql7m5DZhaqMN1B5ZDEBFwAxZDKCLgAswriyyA6/P53LWMOlwEmRMwqyoSZY7AtKpIlDkAk6oiUWYPjKuKRJkdMKoqEmW2bck0/Zhf3smPMpuG+/RCJMqsKXi1Psms6KlIV/Jvyf5wWSSQXUAuEsguIBcJ/HNCbZyesooMRkSeETzsjci+SvKwB/zXotjV0lBmRBahX0VeaWNTWeQL2TMhD3sgu4BcJJBdQC4SyC4gFwlkF5CLBLILyEUMuTwA8LRukc5Vq4IAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthArtilceLogo);
export default __webpack_public_path__ + "static/media/health-artilce-logo.c514aa688b86513a374a530c076c9b1c.svg";
export { ForwardRef as ReactComponent };